/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type ExpenseLineExpenseType = (typeof ExpenseLineExpenseType)[keyof typeof ExpenseLineExpenseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExpenseLineExpenseType = {
  housing: "housing",
  consumption: "consumption",
  life_style: "life_style",
  other: "other",
  loan: "loan",
  "financial-product": "financial-product",
  insurance: "insurance",
} as const;
